import React from 'react'
import { Row } from "react-bootstrap"
import '../../../../styles/css/DisabledCard.css'

function DisabledCard(props) {

    //Parametros de entrada.
    const inputParam_Display = (props.display !== undefined && props.display !== null) ? props.display : true;

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <Row className='child1 layerBlockContent mx-auto' style={ { display: inputParam_Display ? "block" : "none" } } />
    );
}

export default DisabledCard;

